import React, { useState, useEffect } from 'react';
import './Advisory.css';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';

function ServicePlan({ id, title, price, features, type, onAddToCart, onRemoveFromCart, isInCart }) {
  const { currencySymbol } = useSettings();
  
  return (
    <div className={`plan-card ${type}`}>
      <h4>{title}</h4>
      <div className="price">{currencySymbol}{price}<span>/month</span></div>
      <ul>
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      {isInCart ? (
        <button 
          className="select-plan remove-btn"
          onClick={() => onRemoveFromCart(id)}
        >
          Remove from Cart
        </button>
      ) : (
        <button 
          className="select-plan"
          onClick={() => onAddToCart({ id, name: title, price })}
        >
          Add to Cart
        </button>
      )}
    </div>
  );
}

function Advisory() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { addToCart, removeFromCart, isInCart } = useCart();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/advisory`);
        
        // Add unique IDs to each service
        if (response.data && response.data.services) {
          if (response.data.services.standard) {
            response.data.services.standard.id = 'advisory-standard';
          }
          if (response.data.services.premium) {
            response.data.services.premium.id = 'advisory-premium';
          }
        }
        
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
  };

  const handleRemoveFromCart = (itemId) => {
    removeFromCart(itemId);
    // Optional: Show a confirmation message
    alert(`Item removed from cart!`);
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!data) return <div className="error">No data available</div>;

  return (
    <div className="advisory-page">
      <section className="advisory-hero">
        <h1>{data.hero.title}</h1>
        <p className="hero-subtitle">{data.hero.subtitle}</p>
      </section>

      <section className="services-detail">
        <div className="service-container">
          <h2>Business Advisory Plans</h2>
          <div className="plans-grid">
            <ServicePlan {...data.services.standard} type="standard" onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} isInCart={isInCart('advisory-standard')} />
            <ServicePlan {...data.services.premium} type="premium" onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} isInCart={isInCart('advisory-premium')} />
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <h2>Why Choose Our Business Advisory Services?</h2>
        <div className="benefits-grid">
          {data.benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="contact-section">
        <h2>Need Business Advisory Services?</h2>
        <p>Contact us for expert business guidance and strategy</p>
        <div className="contact-info">
          <p>Email: <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a></p>
          <p>Phone: <a href={`tel:${data.contact.phone.replace(/\s+/g, '')}`}>{data.contact.phone}</a></p>
        </div>
      </section>
    </div>
  );
}

export default Advisory; 